import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import React from 'react'; 
// type Props = {
//   children: JSX.Element;
//   roles?: string[]; // ✅ Accept multiple roles now
// };

// const ProtectedRoute = ({ children, role }:
//     {
//   children: React.ReactElement; // ✅ use React.ReactElement instead of JSX.Element
//   role?: string | string[];
// }
// ) => {
//   const { user } = useAuth();

//   if (!user) return <Navigate to="/" replace />;

//   if (role && !role.includes(user.role)) {
//     return <Navigate to="/" replace />;
//   }
// //   if (role && user.role !== role) return <Navigate to="/unauthorized" replace />;

//   return children;
// };

// export default ProtectedRoute;
const ProtectedRoute = ({
  children,
  role,
}: {
  children: React.ReactElement;
  role?: string | string[];
}) => {
  const { user } = useAuth();

  if (!user) return <Navigate to="/" replace />;

  // Explicitly ensure roleList is always a string array
  const roleList: string[] = Array.isArray(role) ? role : role ? [role] : [];

  if (roleList.length > 0 && !roleList.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
// import React from 'react'; // ✅ Add this line
// import { Navigate } from 'react-router-dom';
// import { useAuth } from '../context/AuthContext';

// const ProtectedRoute = ({
//   children,
//   role,
// }: {
//   children: React.ReactElement; // ✅ use React.ReactElement instead of JSX.Element
//   role?: string;
// }) => {
//   const { user } = useAuth();

//   if (!user) return <Navigate to="/login" replace />;
//   if (role && user.role !== role) return <Navigate to="/dashboard" replace />;

//   return children;
// };

// export default ProtectedRoute;
